import React, {useState} from "react";
import PdfBackground from "../../../card/pdfCard/pdfBackground";
import { MODALS } from "../../../../config/images";
const EditPdfModal = ({ 
  isOpen, 
  onClose, 
  pdfFile, 
  title, 
  onTitleChange, 
  onSave,
  isSaveDisabled = false,
  isSaving = false
}) => {

  const [characterCount, setCharacterCount] = useState(title?.length || 0);

  const handleTitleChange = (e) => {
    const input = e.target.value;
    if (input.length <= 50) {
      onTitleChange(input);
      setCharacterCount(input.length);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[33.33%] sm:w-[50%] w-[95%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
        

        <div className='flex justify-end'>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md"
            disabled={isSaving}
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>

        <div className="flex flex-col items-center justify-center px-8 pb-3">
            <div className="relative overflow-hidden drop-shadow-manual rounded-lg h-[320px] w-[230px] mb-4">
              <PdfBackground pdfFile={pdfFile} />
              <div className="absolute inset-0 bg-opacity-50 p-4 bg-[#184A7D80] rounded-lg flex justify-center items-center overflow-auto">
                  
              <textarea
                value={title}
                onChange={handleTitleChange}
                className="bg-transparent w-full text-[18px] text-white font-itcbold text-center outline-none resize-none"
                rows={5}
                maxLength={50}
                style={{ 
                  textDecoration: 'underline'
                }}
                disabled={isSaving}
              />

              </div>
            </div>
    

              <button
                onClick={onSave}
                disabled={isSaveDisabled}
                className={`px-4 py-2 font-itcbook text-[16px] ${
                  isSaveDisabled 
                    ? "text-gray-400 cursor-not-allowed" 
                    : "text-blue underline"
                }`}
              >
              {isSaving ? (
                <>
<div className="flex items-center gap-1">
                    <svg className="w-4 h-4 mr-2 -ml-1 text-current animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Guardando...
</div>
                </>
              ) : (
                "Guardar"
              )}
              </button>
        </div>

      </div>
    </div>
  );
};

export default EditPdfModal;